// extracted by mini-css-extract-plugin
export var attribution = "_aw-4";
export var authorName = "_aw-5";
export var quote = "_aw-3";
export var testimonial = "_aw-2";
export var trustedBy = "_aw-0";
export var trustedByLabel = "_aw-1";